import { render, staticRenderFns } from "./relatorioReflexos.vue?vue&type=template&id=8d9515ea&scoped=true&"
import script from "./relatorioReflexos.vue?vue&type=script&lang=js&"
export * from "./relatorioReflexos.vue?vue&type=script&lang=js&"
import style0 from "./relatorioReflexos.vue?vue&type=style&index=0&id=8d9515ea&scoped=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9515ea",
  null
  
)

export default component.exports